const jobs = {
  update: {
    summary: {
      supplier: 'ציים',
      notRouted: 'לא חולק',
    },
  },
  forms: {
    information: {
      supplier: {
        header: 'ציים',
      },
    },
  },
  table: {
    actions: {
      route: 'הפץ',
    },
    statuses: {
      new: 'לא חולק',
      routed: 'חולק',
    },
    cells: {
      supplier: {
        none: 'אין ציים',
      },
    },
    filters: {
      supplier: 'ציים',
    },
    headers: {
      supplier: 'ציים',
    },
  },
};

export default jobs;
